import React from 'react';
import { Button, Tooltip } from '@mui/material';

const EditWarehouseTrigger = ({ onOpen }) => {
  return (
    <Tooltip title="Edit warehouse and zone names">
      <Button onClick={onOpen} size="small" variant="text" color="primary" sx={{ padding: 0, margin: 0, minWidth: 'unset', textTransform: 'none' }}>
        Edit
      </Button>
    </Tooltip>
  );
};

export default EditWarehouseTrigger;
